/* ==========================================================================
   Bazan 2026 — promo slider (scroll-snap, PC multi / mobile 1, dot nav)
   ========================================================================== */
(function () {
  'use strict';

  function initPromo(root) {
    var track = root.querySelector('[data-bz-ptrack]');
    if (!track) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.bz-promo__slide'));
    var dotsWrap = root.querySelector('[data-bz-pdots]');
    if (slides.length < 2) return;

    function getPerView() {
      if (window.innerWidth < 750) return 1;
      var val = parseInt(getComputedStyle(root).getPropertyValue('--bz-promo-per'), 10);
      return (val > 0) ? val : 1;
    }

    function pageCount() {
      return Math.ceil(slides.length / getPerView());
    }

    // Build dots dynamically
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var n = pageCount();
      for (var i = 0; i < n; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bz-promo__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('data-bz-pdot', i);
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.addEventListener('click', (function(idx) {
          return function() { goTo(idx); };
        })(i));
        dotsWrap.appendChild(btn);
      }
    }

    function getDots() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-bz-pdot]'));
    }

    function setActive(pageIdx) {
      getDots().forEach(function (d, di) {
        d.classList.toggle('is-active', di === pageIdx);
      });
    }

    function currentPage() {
      var perView = getPerView();
      var pos = track.scrollLeft;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs((s.offsetLeft - track.offsetLeft) - pos);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return Math.floor(best / perView);
    }

    function goTo(pageIdx) {
      var perView = getPerView();
      var slideIdx = Math.min(pageIdx * perView, slides.length - 1);
      track.scrollTo({ left: slides[slideIdx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(pageIdx);
    }

    function syncDotsVis() {
      if (!dotsWrap) return;
      var scrollable = (track.scrollWidth - track.clientWidth) > 2;
      dotsWrap.style.display = scrollable ? '' : 'none';
    }

    function onResize() {
      buildDots();
      syncDotsVis();
      setActive(0);
    }

    window.addEventListener('resize', onResize);

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { setActive(currentPage()); }, 80);
    }, { passive: true });

    buildDots();
    setActive(0);
    syncDotsVis();
  }

  function boot() {
    document.querySelectorAll('[data-bz-promo]').forEach(initPromo);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-bz-promo]').forEach(initPromo);
  });
})();
